import { IOptions, Notifier } from '@airbrake/browser';
import { isNil as _isNil, noop as _noop } from 'lodash';

export const airbrakeServiceMock = {
	notify: _noop
} as AirbrakeService;

export default class AirbrakeService {
	private readonly logPrefix = 'AirbrakeService';
	private airbrakeClient: Notifier;

	constructor(options: IOptions) {
		if (_isNil(options)) {
			throw new Error(`${this.logPrefix} missing options!`);
		}

		this.airbrakeClient = new Notifier(options);
	}

	async notify({ error, params, context }) {
		try {
			await this.airbrakeClient.notify({
				error,
				params,
				context
			});
		} catch (e) {
			console.error(`${this.logPrefix} failed notifying`, e);
		}
	}
}
